<template>
  <div class="containerdiv" v-if="productData && productData.id">
    <a :href="phone ? `tel:${phone}` : '#'" class="contact">
      <van-icon name="service-o" size="16" />
      <span>客服</span>
    </a>
    <div class="carousel">
      <van-swipe
        width="100%"
        height="375"
        class="swiper"
        show-indicators
        :duration="400"
        :autoplay="0"
      >
        <template>
          <van-swipe-item
            class="swiper-item"
            v-if="productData.video && productData.video.url"
          >
            <video
              :src="productData.video.url"
              class="image-wrapper"
              play-btn-position="center"
              show-mute-btn
              page-gesture
              controls
              autoplay
              x5-video-player-type="h5-page"
              width="100%"
            ></video>
          </van-swipe-item>
          <van-swipe-item
            class="swiper-item"
            v-for="(item, index) in pictures"
            :key="index"
          >
            <van-image lazy-load :src="item" class="image-wrapper"></van-image>
          </van-swipe-item>
        </template>
      </van-swipe>
    </div>

    <!-- 活动横幅 -->

    <!-- <div
      class="active-div"
      v-if="productData.activity && productData.activity == 1"
    >
      <div class="active-root d-flex flex-row" @click="handleActive">
        <div class="active-left d-flex flex-column justify-content-center">
          <div class="active-price-box d-flex flex-row justify-content-between">
            <div>
              <span class="active-price-tip">¥</span>
              <span class="active-price">{{ productData.price }}</span>
            </div>
            <span class="active-m-price flex-1"
              >¥{{ productData.nominalPrice }}</span
            >
            <span class="active-volume"
              >已售{{ productData.activity.activityIns[0].salesVolume }}</span
            >
          </div>
          <div class="pro-box">
            <div class="progress-box">
              <progress
                stroke-width="12"
                :percent="
                  (productData.activity.activityIns[0].salesVolume /
                    productData.activity.quantity) *
                  100
                "
                activeColor="#fa436a"
                active
              />
            </div>
          </div>
        </div>
        <div
          class="active-right d-flex flex-column justify-content-center align-items-center"
        >
          <van-image
            lazy-load
            class="activ-image"
            :src="productData.activity.icon"
          ></van-image>
          <span
            >距抽奖还剩{{
              productData.activity.quantity -
              productData.activity.activityIns[0].salesVolume
            }}件</span
          >
        </div>
      </div>
    </div> -->

    <!-- 团购横幅 -->
    <div
      class="goup-div themeBGColor d-flex flex-row align-items-center border-bottom"
      v-if="productData.activity == 1"
    >
      <div class="flex-1 pl-3 pr-3 pt-1 pb-1">
        <div class="fs-22 text-white d-flex flex-row align-items-center">
          <span class="fs-16">团购价 ¥</span>
          {{ productData.activityPrice }}
          <span class="fs-12 border ml-1 pl-1 pr-1"
            >{{ productData.maxMemberCount }}人拼</span
          >
        </div>
        <div class="fs-14 text-white">
          <span class="fs-12">原价</span>
          ¥{{ productData.price }}
          <span class="fs-12 m-price">¥{{ productData.nominalPrice }}</span>
        </div>
      </div>
      <div
        class="bg-white p-2 d-flex flex-column justify-content-around align-items-center"
      >
        <div class="fs-14 themeFontColor" v-if="activityState !== 0">
          距拼购结束还剩
        </div>
        <div class="fs-14 themeFontColor" v-else>距拼购开始还剩</div>
        <div class="d-flex flex-row justify-content-around align-items-center">
          <div class="p-1 fs-14">{{ time.d }}天</div>
          <div class="themeBGColor text-white p-1 fs-12">
            {{ time.h > 9 ? time.h : "0" + time.h }}
          </div>
          <div :style="{ marginBottom: '0.08rem' }" class="p-1 fs-12">:</div>
          <div class="themeBGColor text-white p-1 fs-12">
            {{ time.m > 9 ? time.m : "0" + time.m }}
          </div>
          <div :style="{ marginBottom: '0.08rem' }" class="p-1 fs-12">:</div>
          <div class="themeBGColor text-white p-1 fs-12">
            {{ time.s > 9 ? time.s : "0" + time.s }}
          </div>
        </div>
      </div>
    </div>
    <!-- 限时折扣横幅 -->
    <div
      class="goup-div themeBGColor d-flex flex-row align-items-center border-bottom"
      v-if="productData.activity == 2"
    >
      <div class="flex-1 pl-3 pr-3 pt-1 pb-1">
        <div class="fs-22 text-white d-flex flex-row align-items-center">
          <span class="fs-16">¥</span>
          {{ productData.activityPrice }}
          <span class="fs-12 border ml-1 pl-1 pr-1">折扣价</span>
        </div>
        <div class="fs-14 text-white">
          <span class="fs-12">原价</span>
          ¥{{ productData.price }}
          <span class="fs-12 m-price">¥{{ productData.nominalPrice }}</span>
        </div>
      </div>
      <div
        class="bg-white p-2 d-flex flex-column justify-content-around align-items-center"
      >
        <div class="fs-14 themeFontColor" v-if="activityState !== 0">
          距活动结束还剩
        </div>
        <div class="fs-14 themeFontColor" v-else>距活动开始还剩</div>
        <div class="d-flex flex-row justify-content-around align-items-center">
          <div class="p-1 fs-14">{{ time.d }}天</div>
          <div class="themeBGColor text-white p-1 fs-12">
            {{ time.h > 9 ? time.h : "0" + time.h }}
          </div>
          <div :style="{ marginBottom: '0.08rem' }" class="p-1 fs-12">:</div>
          <div class="themeBGColor text-white p-1 fs-12">
            {{ time.m > 9 ? time.m : "0" + time.m }}
          </div>
          <div :style="{ marginBottom: '0.08rem' }" class="p-1 fs-12">:</div>
          <div class="themeBGColor text-white p-1 fs-12">
            {{ time.s > 9 ? time.s : "0" + time.s }}
          </div>
        </div>
      </div>
    </div>

    <div class="introduce-section">
      <div
        class="price-box d-flex flex-row justify-content-between align-items-center"
      >
        <span class="title text-left flex-1">{{ productData.name }}</span>
        <!-- <div class="d-flex flex-row" v-if="productData.activity&&productData.activity.type==2">
          <span class="con t-r red">下单可</span>
          <div class="activBtn" @click="handleActive">抽奖</div>
        </div>-->
      </div>
      <div class="price-box" v-if="!!!productData.activity">
        <span class="price-tip">¥</span>
        <span class="price">{{ productData.price }}</span>
        <span
          class="price"
          v-if="productData.isIntegral === 1"
          style="margin-left: 5px"
          >+ {{ productData.mostIntegralCanUse }}积分</span
        >
        <span class="m-price" v-if="productData.nominalPrice"
          >¥{{ productData.nominalPrice }}</span
        >
        <!-- <span class="coupon-tip">7折</span> -->
      </div>
      <div class="bot-row">
        <span>销量: {{ productData.salesVolume }}</span>
        <span
          >运费:
          <span v-if="productData.freightType == 2">包邮</span>
          <span v-if="productData.freightType == 3">不包邮</span>
          <span v-if="productData.freightType == 4">到付</span>
          <!-- <span v-else>{{ productData.freight }}元</span> -->
        </span>
        <span v-if="categoryType == 1">库存: {{ productData.stock }}</span>
        <span>浏览量: {{ productData.scanNum }}</span>
      </div>
    </div>

    <div class="c-list">
      <div
        v-if="productData.productStocks && productData.productStocks.length > 0"
        class="c-row b-b"
        @click="toggleSpec"
      >
        <span class="tit">购买类型</span>
        <div class="con text-left">
          <!-- <span class="selected-span">{{ activespan }}</span> -->
          <span class="selected-span" v-if="activespanShow"
            ><span class="selectedType">选择：</span>{{ activespan }}</span
          >
          <span class="selected-span" v-else
            ><span class="selectedType">已选：</span>{{ activespan }}</span
          >
        </div>
        <span class="yticon icon-you"></span>
      </div>

      <div
        class="c-row b-b"
        @click="toggleCouponList"
        v-if="couponList && couponList.length !== 0"
      >
        <span class="tit">优惠券</span>
        <span class="con t-r red">领取优惠券</span>
        <span class="yticon icon-you"></span>
      </div>
      <!--      <div class="c-row b-b">-->
      <!--				<span class="tit">促销活动</span>-->
      <!--				<div class="con-list">-->
      <!--					<span>新人首单送20元无门槛代金券</span>-->
      <!--					<span>订单满50减10</span>-->
      <!--					<span>订单满100减30</span>-->
      <!--					<span>单笔购买满两件免邮费</span>-->
      <!--				</div>-->
      <!--      </div> -->
      <!-- <div class="c-row b-b">
        <span class="tit">服务</span>
        <div class="bz-list con">
          <span>7天无理由退换货 ·</span>
          <span>假一赔十 ·</span>
        </div>
      </div> -->
    </div>
    <div class="c-list mt-2" v-if="productData.activity == 1">
      <div class="c-row flex-column align-items-start">
        <div class="fs-14 title">
          已经有{{ productData.memberCount }}人参与活动
        </div>
        <template
          v-if="
            productData.groupBuy &&
            productData.groupBuy.length !== 0 &&
            !leaderMemberId
          "
        >
          <div
            v-for="(item, index) in productData.groupBuy"
            :key="index"
            class="position-relative pt-1 pb-1 w-100 d-flex flex-row justify-content-between align-items-center"
          >
            <div
              :style="{
                width:
                  20 +
                  (item.groupBuyList && item.groupBuyList.length <= 2
                    ? item.groupBuyList.length
                    : 2) *
                    20 +
                  'px',
                height: '40px',
              }"
            >
              <div
                class="position-absolute d-flex flex-row align-items-center rounded-circle"
                :style="{
                  height: '40px',
                  width: '40px',
                  left: cIndex * 20 + 'px',
                  border: '2px white solid',
                }"
                v-for="(cItem, cIndex) in item.groupBuyList"
                :key="cIndex"
                v-if="cIndex <= 3"
              >
                <van-image
                  lazy-load
                  round
                  width="36"
                  height="36"
                  :src="cItem.memberAvatar"
                />
              </div>
            </div>
            <div class="ml-3 flex-1">
              <div>
                <span>还差</span>
                <span
                  class="themeFontColor"
                  v-if="item.groupBuyList && item.groupBuyList.length"
                  >{{
                    productData.maxMemberCount - item.groupBuyList.length
                  }}人</span
                >
                <span>参团</span>
              </div>
              <div v-if="groupEndTimes['item_' + item.groupBuyGroupId].time">
                <span>剩余</span>
                <span>{{
                  groupEndTimes["item_" + item.groupBuyGroupId].time.d + "天"
                }}</span>
                <span>{{
                  groupEndTimes["item_" + item.groupBuyGroupId].time.h >= 10
                    ? groupEndTimes["item_" + item.groupBuyGroupId].time.h
                    : "0" + groupEndTimes["item_" + item.groupBuyGroupId].time.h
                }}</span>
                <span>:</span>
                <span>{{
                  groupEndTimes["item_" + item.groupBuyGroupId].time.m >= 10
                    ? groupEndTimes["item_" + item.groupBuyGroupId].time.m
                    : "0" + groupEndTimes["item_" + item.groupBuyGroupId].time.m
                }}</span>
                <span>:</span>
                <span>{{
                  groupEndTimes["item_" + item.groupBuyGroupId].time.s >= 10
                    ? groupEndTimes["item_" + item.groupBuyGroupId].time.s
                    : "0" + groupEndTimes["item_" + item.groupBuyGroupId].time.s
                }}</span>
              </div>
            </div>
            <div
              class="pl-2 pr-2 pt-1 pb-1 themeBGColor text-white"
              :style="{ borderRadius: '50px' }"
              @click="handleCommit(productData.activity, item.groupBuyGroupId)"
            >
              去参团
            </div>
          </div>
        </template>
        <template v-else>
          <div
            class="position-relative pt-1 pb-1 w-100 d-flex flex-row justify-content-between align-items-center"
          >
            <div
              :style="{
                height: '40px',
              }"
            >
              <div
                class="position-absolute d-flex flex-row align-items-center rounded-circle"
                :style="{
                  height: '40px',
                  width: '40px',
                  border: '2px white solid',
                }"
                v-for="(cItem, cIndex) in productData.groupBuy.groupBuyList"
                :key="cIndex"
              >
                <van-image
                  lazy-load
                  round
                  width="36"
                  height="36"
                  :src="cItem.memberAvatar"
                />
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <!-- 评价 -->
    <!-- <div class="eva-section">
			<div class="e-header">
				<span class="tit">评价</span>
				<span>(86)</span>
				<span class="tip">好评率 100%</span>
				<span class="yticon icon-you"></span>
			</div>
			<div class="eva-box">
				<image class="portrait" src="http://img3.imgtn.bdimg.com/it/u=1150341365,1327279810&fm=26&gp=0.jpg" mode="aspectFill"></image>
				<div class="right">
					<span class="name">Leo yo</span>
					<span class="con">商品收到了，79元两件，质量不错，试了一下有点瘦，但是加个外罩很漂亮，我很喜欢</span>
					<div class="bot">
						<span class="attr">购买类型：XL 红色</span>
						<span class="time">2019-04-01 19:21</span>
					</div>
				</div>
			</div>
    </div>-->
    <div
      class="detail-desc"
      v-if="productData.attrItemsJson && productData.attrItemsJson.length > 0"
    >
      <div class="d-header">
        <span>规格属性</span>
      </div>
    </div>
    <div
      class="c-list"
      v-for="(item, index) in productData.attrItemsJson"
      :key="index"
    >
      <div class="c-row border-bottom">
        <span class="tited">{{ item.name }}</span>
      </div>
      <div
        class="c-row border-bottom"
        v-for="(cItem, cIndex) in item.items"
        :key="cIndex"
      >
        <span class="tit">{{ cItem.name }}</span>
        <div class="bz-list con">
          <span>{{ cItem.value }}</span>
        </div>
      </div>
    </div>
    <div class="detail-desc" v-if="productData.content">
      <div class="d-header">
        <span>图文详情</span>
      </div>
      <div class="htmlContent" v-html="productData.content"></div>
    </div>

    <!-- 底部操作菜单 -->
    <div class="page-bottom">
      <!-- <div class="authBox" @click="toWechatAuth" v-if="!userInfo.avatar"></div> -->
      <router-link to="/?code=首页" class="p-b-btn">
        <span class="yticon icon-xiatubiao--copy"></span>
        <span>首页</span>
      </router-link>
      <router-link
        to="/?code=购物车"
        class="p-b-btn"
        v-if="categoryType == 1 && productData.activity !== 1"
      >
        <span class="yticon icon-gouwuche"></span>
        <span>购物车</span>
      </router-link>
      <div
        class="p-b-btn"
        :class="{ active: favorite }"
        @click="toFavorite"
        v-if="categoryType == 1"
      >
        <span class="yticon icon-shoucang"></span>
        <span>收藏</span>
      </div>

      <div v-if="productData.activity == 0" class="action-btn-group">
        <div
          class="action-btn no-border add-cart-btn"
          @click="handleAddCart()"
          v-if="categoryType == 1"
        >
          加入购物车
        </div>

        <div
          :class="[
            'no-border',
            'buy-now-btn',
            categoryType == 1 ? 'action-buy' : 'action-buy-two',
          ]"
          @click="handleCommit()"
        >
          立即购买
        </div>
      </div>
      <div v-if="productData.activity == 1" class="action-btn-group">
        <div class="action-btn no-border add-cart-btn" @click="handleCommit()">
          <div>单独购买</div>
        </div>
        <div
          class="no-border buy-now-btn action-buy"
          @click="handleCommit(productData.activity)"
          v-if="!leaderMemberId"
        >
          <div>我要开团</div>
        </div>
        <div
          v-else
          class="no-border buy-now-btn action-buy-two"
          @click="handleCommit(productData.activity, leaderMemberId)"
        >
          <div>参与{{ productData.groupBuy.leaderMemberName }}的拼团</div>
        </div>
      </div>

      <div v-if="productData.activity == 2" class="action-btn-group">
        <!-- <div class="action-btn no-border add-cart-btn" @click="handleAddCart()">
          加入购物车
        </div> -->
        <div
          class="no-border buy-now-btn action-buy-two"
          @click="handleCommit(productData.activity)"
        >
          立即购买
        </div>
      </div>
    </div>

    <!-- 规格-模态层弹窗 -->
    <div
      class="popup spec"
      :class="specClass"
      @click="toggleSpec"
    >
      <!-- 遮罩层 -->
      <div class="mask"></div>
      <div
        class="layer attr-content"
        @click.stop="stopPrevent"
        @touchmove.stop
      >
        <div class="a-t">
          <van-image
            lazy-load
            class="a-t-img"
            radius="4"
            :src="picture"
            width="85"
            height="85"
          />
          <div class="right" v-if="productData.activity == 1">
            <span class="price">
              <span v-if="!type">
                ¥{{
                  minactivityPrice == maxactivityPrice
                    ? minactivityPrice
                    : minactivityPrice + "～" + maxactivityPrice
                }}
              </span>
              <!-- <span v-if="!!!groupId && !!type">
                ¥{{
                  minGroupLeaderPrice == maxGroupLeaderPrice
                    ? maxGroupLeaderPrice
                    : minGroupLeaderPrice + "～" + maxGroupLeaderPrice
                }}
              </span> -->
              <span v-if="type"> ¥{{ resultActivePrice }} </span>
              <van-tag type="danger">{{ "团购价" }}</van-tag>
            </span>
            <span class="price">
              <span class="fs-12 mr-1">原价</span>
              <span>¥{{ min == max ? max : min + "～" + max }}</span>
            </span>
            <span class="stock">库存：{{ quantity }}件</span>
            <div class="selected">
              <span class="selected-span">{{ activespan }}</span>
            </div>
          </div>
          <div class="right" v-if="productData.activity == 2">
            <span class="price">
              <span>
                ¥{{
                  minactivityPrice == maxactivityPrice
                    ? minactivityPrice
                    : minactivityPrice + "～" + maxactivityPrice
                }}
              </span>
            </span>
            <span class="price">
              <span class="fs-12 mr-1">原价买</span>
              <span>¥{{ min == max ? max : min + "～" + max }}</span>
            </span>
            <span class="stock">库存：{{ quantity }}件</span>
            <div class="selected">
              <span class="selected-span">{{ activespan }}</span>
            </div>
          </div>
          <div class="right" v-if="productData.activity == 0">
            <span class="price">
              <span> ¥{{ resultPrice }} </span>
            </span>
            <span class="stock"
              ><span style="color: #000; font-weight: 500">库存：</span
              >{{ quantity }}件</span
            >
            <div class="selected">
              <!-- <span class="selected-span">{{ activespan }}</span> -->
              <span class="selected-span" v-if="activespanShow"
                ><span class="selectedType">选择：</span>{{ activespan }}</span
              >
              <span class="selected-span" v-else
                ><span class="selectedType">已选：</span>{{ activespan }}</span
              >
            </div>
          </div>
        </div>
        <div class="attr-scroll">
          <div v-for="(value, key) in spec" :key="key" class="attr-list">
            <span>{{ key }}</span>
            <div class="item-list">
              <div
                class="item-item tit"
                v-for="(item, index) in value"
                :key="index"
                :class="{
                  disabled: !item.have,
                  selected: activeSpec[key] == item.value,
                }"
                @click="handleFloatItemTap(key, item)"
              >
                <div
                  class="item-color"
                  v-if="item.type == 2"
                  :style="{ backgroundColor: item.color }"
                />
                <image
                  class="item-image"
                  v-if="item.type == 1"
                  :src="item.picture"
                />
                <span>{{ item.value }}</span>
              </div>
            </div>
          </div>
          <div class="attr-list">
            <span>数量</span>
            <div class="item-list">
              <van-field name="stepper">
                <template #input>
                  <van-stepper v-model="num" :min="1" :max="maxNum" />
                </template>
              </van-field>
              <!-- <uni-number-box
                ref="numberBox"
                class="step"
                :min="1"
                :max="maxNum"
                :value="num > maxNum ? maxNum : num"
                :isMax="num >= maxNum"
                :isMin="num === 1"
                @eventChange="numberChange"
              ></uni-number-box> -->
            </div>
          </div>
        </div>
        <div class="btnCom flex-center" @click="handleSuccess">完成</div>
      </div>
    </div>

    <!--    优惠券弹层-->
    <van-popup
      v-model="showCoupon"
      position="bottom"
      :style="{ maxHeight: '40%', background: '#f3f3f3' }"
      safe-area-inset-bottom
    >
      <my-coupon-receive-list></my-coupon-receive-list>
    </van-popup>
  </div>
</template>

<script>
import { myMixins } from "@/mixins";
import uniNumberBox from "@/components/uni-number-box.vue";

import { mapState } from "vuex";
export default {
  components: {
    uniNumberBox,
  },
  mixins: [myMixins],
  data() {
    return {
      totalAttri: [],
      leaderMemberId: "",
      resultPrice: 0,
      resultActivePrice: 0,
      resultAttri: "",
      isShow: true,
      productId: 0,
      specClass: "none",
      specSelected: [],
      productData: {},
      pictures: [],
      video: [],
      spec: null,
      activeSpec: {},
      activespan: "",
      min: 0,
      max: 0,
      minNominal: 0,
      maxNominal: 0,
      minactivityPrice: 0,
      maxactivityPrice: 0,
      minGroupLeaderPrice: 0,
      maxGroupLeaderPrice: 0,
      quantity: 0,
      picture: null,
      num: 1,
      maxNum: 2,
      isMax: false,
      stockId: null,
      parameter: null,
      favorite: false,
      okType: "",
      time: {
        d: 0,
        h: 0,
        m: 0,
        s: 0,
      },
      groupEndTimes: {},
      type: null,
      groupId: null,
      showCoupon: false,
      couponList: [],
      categoryType: "",
      tryTime: 10,
      playTime: null,
      IsEnd: false,
      activespanShow: true,
      phone: "",
      activityState: null,
    };
  },
  mounted() {
    // let avatar = localStorage.getItem("avatar") || '';

    // if (this.existField(this.userInfo.avatar) || this.existField(avatar)) {
    // }else{
    //   this.toWechatAuth();
    // }
    this.resultPrice = 0;
    let query = this.$route.query;
    this.activityState = parseFloat(query.activityState);
    let id = query.id;
    this.productId = id;
    this.leaderMemberId = query.g;
    this.categoryType = query.type;
    this.getProduct();
    this.checkCollect();
    this.getPhone();
    this.getCouponList();
  },
  computed: {
    ...mapState(["hasLogin", "userInfo"]),
  },
  destroyed() {
    clearInterval(this.timeIn);
    clearInterval(this.playTime);
  },
  methods: {
    // existField(filed){
    //   let flag = true;
    //   if(filed == undefined || filed == null || filed == '' || filed == 'null'){
    //     flag = false;
    //   }
    //   return flag;
    // },
    // toWechatAuth() {
    //   this.$router.push({
    //     path: "/pages/WechatAuth",
    //     query: {
    //       redirectUrl: this.$route.fullPath,
    //     },
    //   });
    // },
    getCouponList() {
      this.$http.request(this.$http.pathMap.couponReceiveList).then((res) => {
        console.log(res.data);
        this.couponList = res.data;
      });
    },
    getPhone() {
      this.$http.request(this.$http.pathMap.getPhone, "get").then((res) => {
        // console.log(res);
        this.phone = res.data;
      });
    },
    toggleCouponList() {
      this.showCoupon = !this.showCoupon;
    },
    share(title, desc, img) {
      // console.log("11313");
      let that = this;
      that.$http.getJsSdkConfig().then((res) => {
        that.updateShare(title, desc, img);
      });
    },
    changeURLArg(url, arg, arg_val) {
      var pattern = arg + "=([^&]*)";
      var replaceText = arg + "=" + arg_val;
      if (url.match(pattern)) {
        var tmp = "/(" + arg + "=)([^&]*)/gi";
        tmp = url.replace(eval(tmp), replaceText);
        return tmp;
      } else {
        if (url.match("[\?]")) {
          return url + "&" + replaceText;
        } else {
          return url + "?" + replaceText;
        }
      }
      return url + "\n" + arg + "\n" + arg_val;
    },
    updateShare(title, desc, img) {
      desc ? desc : localStorage.getItem("desc");
      img ? img : localStorage.getItem("logo");
      let href = location.href;
      let userId = localStorage.getItem("userId");
      if (userId) {
        if (href.indexOf("?") > -1 && href.indexOf("userId") == -1) {
          href += "&userId=" + userId;
        } else {
          href = this.changeURLArg(href, "userId", userId);
        }
      }
      let share = {
        title: title, // 分享标题
        desc: desc || "", // 分享描述
        link: href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: img, // 分享图标
      };
      // this.$dialog.alert({
      //   title: '提示',
      //   message: JSON.stringify(share)
      // })
      ///朋友和QQ
      window.wx.updateAppMessageShareData({
        ...share,
      });
      ///朋友圈和空间
      window.wx.updateTimelineShareData({
        ...share,
      });
      ///微博
      window.wx.onMenuShareWeibo({
        ...share,
      });
    },
    fomartHtmlImg() {
      let htmlContent = document.getElementsByClassName("htmlContent")[0];
      let imgs = htmlContent.getElementsByTagName("img");
      let screenWidth = document.body.clientWidth;
      imgs.forEach((element) => {
        let width = element.getAttribute("width");
        if (width && width * 1 > screenWidth) {
          element.removeAttribute("width");
          element.removeAttribute("height");
        }
      });
    },
    //获得商品信息
    getProduct() {
      let paramsId = "/0";
      let url = "";
      if (this.leaderMemberId) {
        paramsId = `/${this.leaderMemberId}`;
      }
      if (this.categoryType == 3 || this.leaderMemberId) {
        url = this.$http.pathMap.virtualInfo;
      } else {
        url = this.$http.pathMap.productInfo;
      }
      this.$http.request(url + "/" + this.productId + paramsId).then((res) => {
        this.productData = res.data;
        if (res.data.productStocks.length !== 0)
          this.totalAttri = JSON.parse(res.data.productStocks[0].data);
        this.pictures = res.data.picture;
        this.video = [];
        this.setTitle(res.data.name);
        let that = this;
        that.$nextTick(() => {
          that.share(
            that.productData.name,
            that.productData.promotionName,
            that.pictures && that.pictures.length > 0 ? that.pictures[0] : ""
          );
          that.fomartHtmlImg();
        });
        this.parameter = res.data.spec_config
          ? JSON.parse(res.data.spec_config)
          : null;
        var spec = {};
        var specItems = res.data.spec_config
          ? JSON.parse(res.data.spec_config)
          : [];
        var productStocks = res.data.productStocks;
        for (let specIiem of specItems) {
          let key = specIiem.name;
          spec[key] = [];
          for (let valueItem of specIiem.items) {
            spec[key].push({
              value: valueItem.name,
              picture: valueItem.picture,
              color: valueItem.color,
              type: specIiem.type,
              have: false,
            });
          }
        }
        this.spec = spec;
        this.computePect();
        this.computePriceAndQuantiy();
        this.computeActivespan();
        if (this.productData.activity == 1 && !this.leaderMemberId) {
          this.startInterval1();
        } else if (this.productData.activity == 2) {
          this.startInterval2();
        } else if (this.leaderMemberId) {
          this.startInterval3();
        }
      });
    },
    // 获取当前时间
    getNowTime() {
      const yy = new Date().getFullYear();
      const MM =
        new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      const dd =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate();
      const HH =
        new Date().getHours() < 10
          ? "0" + new Date().getHours()
          : new Date().getHours();
      const mm =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      const ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      return yy + "-" + MM + "-" + dd + " " + HH + ":" + mm + ":" + ss;
    },
    startInterval3() {
      //总倒计时
      this.serverTime = new Date(
        this.getNowTime().replace(/-/g, "/")
      ).getTime();
      this.groupEndTime = new Date(
        this.productData.groupBuy.dueTime.replace(/-/g, "/")
      ).getTime();
      let that = this;
      that.timeIn = setInterval(() => {
        that.serverTime += 500;
        let time = that.computeTime(this.serverTime, this.groupEndTime);
        if (time) {
          this.time = time;
        } else {
          // clearInterval(that.timeIn)
          // this.getProduct()
        }
      }, 500);
    },
    //团购定时器
    startInterval1() {
      //总倒计时
      let startTime = "";
      let endTime = "";
      if (this.activityState === 0) {
        startTime = this.getNowTime();
        endTime = this.productData.activityStartTime;
      } else {
        startTime = this.productData.serverTime;
        endTime = this.productData.activityEndTime;
      }
      this.serverTime = new Date(startTime.replace(/-/g, "/")).getTime();
      this.groupEndTime = new Date(endTime.replace(/-/g, "/")).getTime();
      this.groupEndTimes = {};
      for (let item of this.productData.groupBuy) {
        let endTime = new Date(item.dueTime.replace(/-/g, "/")).getTime();
        this.groupEndTimes["item_" + item.groupBuyGroupId] = {
          endTime,
          time: { d: 0, h: 0, m: 0, s: 0 },
        };
      }
      let that = this;
      that.timeIn = setInterval(() => {
        that.serverTime += 500;
        let time = that.computeTime(this.serverTime, this.groupEndTime);
        if (time) {
          this.time = time;
        } else {
          // clearInterval(that.timeIn)
          // this.getProduct()
        }
        for (let key in that.groupEndTimes) {
          let endTime = that.groupEndTimes[key].endTime;
          let time = that.computeTime(that.serverTime, endTime);
          if (time) {
            that.groupEndTimes[key].time = time;
          } else {
            // clearInterval(that.timeIn)
            // this.getProduct()
          }
        }
      }, 500);
    },
    //限时折扣定时器
    startInterval2() {
      //总倒计时
      let startTime = "";
      let endTime = "";
      if (this.activityState === 0) {
        startTime = this.getNowTime();
        endTime = this.productData.activityStartTime;
      } else {
        startTime = this.productData.serverTime;
        endTime = this.productData.activityEndTime;
      }
      this.serverTime = new Date(startTime.replace(/-/g, "/")).getTime();
      this.groupEndTime = new Date(endTime.replace(/-/g, "/")).getTime();
      let that = this;
      that.timeIn = setInterval(() => {
        that.serverTime += 500;
        let time = that.computeTime(this.serverTime, this.groupEndTime);
        if (time) {
          this.time = time;
        } else {
          // clearInterval(that.timeIn)
          // this.getProduct()
        }
      }, 500);
    },
    computeTime(startTime, endTime) {
      if (startTime >= endTime) {
        return false;
      }
      let SS = Math.floor(endTime - startTime) / 1000;
      let d = parseInt(SS / (3600 * 24));
      let h = parseInt((SS - d * 3600 * 24) / 3600);
      let m = parseInt((SS - d * 3600 * 24 - h * 3600) / 60);
      let s = parseInt(SS - d * 3600 * 24 - h * 3600 - m * 60);
      return {
        d,
        h,
        m,
        s,
      };
    },
    setTitle(title) {
      document.title = title;
    },

    handleActive() {
      let type = this.productData.activity.type;
      if (type == 1) {
        this.$router.push({
          path: "/pages/active/active",
          query: {
            productId: this.productId,
          },
        });
      } else {
        this.$router.push({
          path: "/pages/wheel/wheel",
          query: {
            productId: this.productId,
          },
        });
      }
    },

    ///计算pect
    computePect() {
      const productStocks = this.productData.productStocks || [];
      const spec = this.spec || {};
      const activeSpec = this.activeSpec || {};
      for (let key in spec) {
        for (let i = 0; i < spec[key].length; i++) {
          const candidateSpec = Object.assign({}, activeSpec, {
            [key]: spec[key][i].value,
          });
          const candidateKeys = Object.keys(candidateSpec);

          spec[key][i].have = productStocks.some((stock) => {
            if (Number(stock.quantity) <= 0) {
              return false;
            }

            let stockSpec = [];
            try {
              stockSpec = JSON.parse(stock.jsonData || stock.data || "[]");
            } catch (e) {
              return false;
            }

            return candidateKeys.every((candidateKey) =>
              stockSpec.some(
                (stockItem) =>
                  stockItem.name === candidateKey &&
                  stockItem.value === candidateSpec[candidateKey]
              )
            );
          });
        }
      }
      this.spec = Object.assign({}, spec);
    },

    computePriceAndQuantiy() {
      //现价
      let min = 0;
      let max = 0;
      //原价
      let minNominal = this.productData.nominalPrice;
      let maxNominal = this.productData.nominalPrice;
      //活动价
      //团购
      //团员价
      let minactivityPrice = 0;
      let maxactivityPrice = 0;
      if (this.productData.activityPrice == 1) {
        minactivityPrice = this.productData.activityPrice;
        maxactivityPrice = this.productData.activityPrice;
      }
      //限时折扣价
      if (this.productData.activityPrice == 2) {
        minactivityPrice = this.productData.activityPrice;
        maxactivityPrice = this.productData.activityPrice;
      }
      //团长价
      let minGroupLeaderPrice = 0;
      let maxGroupLeaderPrice = 0;
      if (this.productData.activityPrice == 1) {
        minGroupLeaderPrice = this.productData.groupLeaderPrice * 1;
        maxGroupLeaderPrice = this.productData.groupLeaderPrice * 1;
      }
      let picture = this.pictures.length > 0 ? this.pictures[0] : "";
      let lockPicture = false;
      var productStocks = this.productData.productStocks;
      let quantity =
        productStocks && productStocks.length > 0 ? 0 : this.productData.stock;
      var activeSpec = this.activeSpec;
      var spec = this.spec;
      var specItems = this.productData.specItemsJson
        ? JSON.parse(this.productData.specItemsJson)
        : [];

      for (let stock of productStocks) {
        let describe = stock.description;
        let count = 0;
        for (let activeKey in activeSpec) {
          let activeValue = activeSpec[activeKey];
          let str = activeKey + ":" + activeValue;
          for (let pictureItem of specItems) {
            if (pictureItem.key == str && !lockPicture) {
              picture = pictureItem.picture ? pictureItem.picture : picture;
              break;
            }
          }
          let stockData = JSON.parse(stock.jsonData || stock.data);
          stockData.forEach((item) => {
            if (item.name === activeKey && item.value === activeValue) {
              count += 1;
            }
          });
        }

        if (count == Object.keys(activeSpec).length) {
          quantity += stock.quantity; //库存
          //计算现价
          if (min == 0 || stock.price < min) {
            min = stock.price;
          }
          if (max == 0 || stock.price > max) {
            max = stock.price;
          }
          //计算原价
          if (minNominal == 0 || stock.nominalPrice < minNominal) {
            minNominal = stock.nominalPrice;
          }
          if (maxNominal == 0 || stock.nominalPrice > maxNominal) {
            maxNominal = stock.nominalPrice;
          }
          //计算活动价
          //团购
          if (this.productData.activity == 1) {
            //团员价
            if (
              minactivityPrice == 0 ||
              stock.activityPrice * 1 < minactivityPrice * 1
            ) {
              minactivityPrice = stock.activityPrice * 1;
            }
            if (
              maxactivityPrice == 0 ||
              stock.activityPrice * 1 > maxactivityPrice * 1
            ) {
              maxactivityPrice = stock.activityPrice * 1;
            }

            //团长价
            if (
              minGroupLeaderPrice == 0 ||
              stock.groupLeaderPrice * 1 < minGroupLeaderPrice * 1
            ) {
              minGroupLeaderPrice = stock.groupLeaderPrice * 1;
            }
            if (
              maxGroupLeaderPrice == 0 ||
              stock.groupLeaderPrice * 1 > maxGroupLeaderPrice * 1
            ) {
              maxGroupLeaderPrice = stock.groupLeaderPrice * 1;
            }
          }
          //限时折扣
          if (this.productData.activity == 2) {
            //
            if (
              minactivityPrice == 0 ||
              stock.activityPrice * 1 < minactivityPrice * 1
            ) {
              minactivityPrice = stock.activityPrice * 1;
            }
            if (
              maxactivityPrice == 0 ||
              stock.activityPrice * 1 > maxactivityPrice * 1
            ) {
              maxactivityPrice = stock.activityPrice * 1;
            }
          }
          this.resultPrice = 0;
          this.resultActivePrice = 0;
          if (count == Object.keys(spec).length) {
            this.stockId = stock.id;
            if (stock.picture) {
              picture = stock.picture ? stock.picture : picture;
              lockPicture = true;
            }
          }
          console.log(count);
          console.log(this.totalAttri);
          console.log(this.totalAttri.length);

          if (count == this.totalAttri.length) {
            this.stockId = stock.id;
            this.resultPrice = stock.price;
            this.resultActivePrice = stock.activityPrice;
          }
        }
      }
      this.min = min;
      this.max = max;
      this.quantity = quantity;
      this.maxNum = quantity;
      this.picture = picture;
      this.minNominal = minNominal;
      this.maxNominal = maxNominal;
      this.minactivityPrice = minactivityPrice;
      this.maxactivityPrice = maxactivityPrice;
      this.minGroupLeaderPrice = minGroupLeaderPrice;
      this.maxGroupLeaderPrice = maxGroupLeaderPrice;
      if (this.resultPrice == 0) {
        this.resultPrice = min == max ? max : min + "～" + max;
      }
      if (this.resultActivePrice == 0) {
        this.resultActivePrice =
          minactivityPrice == maxactivityPrice
            ? maxactivityPrice
            : minactivityPrice + "～" + maxactivityPrice;
      }
    },

    computeActivespan() {
      var activeSpec = this.activeSpec;
      var spec = this.spec;
      var activespan = "";
      let activeSpecKeys = Object.keys(activeSpec);
      let specKeys = Object.keys(spec);
      if (activeSpecKeys.length == specKeys.length) {
        // activespan += "已选:";
        this.activespanShow = false;
        for (let activeKey in activeSpec) {
          let activeValue = activeSpec[activeKey];
          activespan += '"' + activeValue + '" ';
        }
      } else {
        // activespan += "选择: ";
        this.activespanShow = true;
        for (let key of specKeys) {
          let isHave = false;
          for (let activeKey of activeSpecKeys) {
            if (activeKey == key) {
              isHave = true;
            }
          }
          if (!isHave) {
            activespan += key + " ";
          }
        }
      }
      this.activespan = activespan;
    },

    handleFloatItemTap(key, item) {
      this.num = 1;
      this.maxNum = 2;
      if (!item.have) {
        return;
      }
      var activeSpec = this.activeSpec;
      if (activeSpec[key] == item.value) {
        delete activeSpec[key];
      } else {
        activeSpec[key] = item.value;
      }
      this.activeSpec = activeSpec;
      // console.log(this.activeSpec);
      this.computePect();
      this.computePriceAndQuantiy();
      this.computeActivespan();
    },

    //加入购物车
    handleAddCart() {
      if (this.activityState === 0) {
        return this.$toast("活动暂未开始");
      }
      this.okType = "addCart";
      if (this.categoryType == 2) {
        this.addCart();
      } else {
        let activeSpecKeys = Object.keys(this.activeSpec);
        let specKeys = Object.keys(this.spec);
        if (activeSpecKeys.length != specKeys.length) {
          this.okType = "addCart";
          this.toggleSpec();
        } else {
          this.toggleSpec();
        }
      }
    },
    //加入购物车
    addCart() {
      if (this.hasLogin) {
        let { productId, stockId, num, quantity } = this;
        // console.log(num, stockId, quantity);
        if (num > quantity && this.categoryType == 1) {
          this.$toast("库存不足，无法加入购物车");
          return;
        }

        this.$http
          .request(this.$http.pathMap.cartAdd, "post", {
            productId: productId,
            productStockId: stockId,
            quantity: num,
            selected: true,
          })
          .then((res) => {
            this.$toast("加入购物车成功");
          });
      } else {
        this.$router.push("/pages/public/login");
      }
    },
    handleSuccess() {
      let activeSpecKeys = Object.keys(this.activeSpec);
      let specKeys = Object.keys(this.spec);
      if (activeSpecKeys.length != specKeys.length) {
        this.$toast("请选择" + this.activespan);
      } else {
        this.toggleSpec();
        if (this.okType) {
          if (this.okType == "addCart") {
            this.addCart();
          } else if (this.okType == "commit") {
            this.commit(this.type, this.groupId);
          }
        }
      }
    },
    handleCommit(type, groupId) {
      if (this.activityState === 0) {
        return this.$toast("活动暂未开始");
      }
      if (this.categoryType == 2) {
        this.commit(type, groupId);
      } else {
        let activeSpecKeys = Object.keys(this.activeSpec);
        let specKeys = Object.keys(this.spec);
        if (activeSpecKeys.length != specKeys.length) {
          this.okType = "commit";
          this.type = type;
          this.groupId = groupId;
          if (groupId && !this.leaderMemberId) {
            for (let item of this.productData.groupBuy) {
              if (item.groupBuyGroupId == groupId) {
                for (let u of item.groupBuyList) {
                  if (u.memberId == this.userInfo.id) {
                    this.$toast("您已经参加该团，不能重复参加");
                    return;
                  }
                }
              }
            }
          } else if (this.leaderMemberId) {
            for (let item of this.productData.groupBuy.groupBuyList) {
              if (item.memberId == this.userInfo.id) {
                this.$toast("您已经参加该团，不能重复参加");
                return;
              }
            }
          }
          this.toggleSpec();
        } else {
          this.okType = "commit";
          this.toggleSpec();
          // this.commit(type, groupId);
        }
      }
    },
    commit(activity, groupBuyGroupId) {
      if (this.hasLogin) {
        let { productId, stockId, num, quantity, categoryType } = this;
        if (num > quantity && this.categoryType == 1) {
          this.$toast("库存不足，无法购买");
          return;
        }
        let query = { productId, stockId, num, categoryType };
        if (activity) {
          query.activity = activity;
        }
        if (groupBuyGroupId && !this.leaderMemberId) {
          query.groupBuyGroupId = groupBuyGroupId;
          for (let item of this.productData.groupBuy) {
            if (item.groupBuyGroupId == groupBuyGroupId) {
              for (let u of item.groupBuyList) {
                if (u.memberId == this.userInfo.id) {
                  this.$toast("您已经参加该团，不能重复参加");
                  return;
                }
              }
            }
          }
        } else if (this.leaderMemberId) {
          query.groupBuyGroupId = groupBuyGroupId;
          for (let item of this.productData.groupBuy.groupBuyList) {
            if (item.memberId == this.userInfo.id) {
              this.$toast("您已经参加该团，不能重复参加");
              return;
            }
          }
        }
        this.$router.push({
          path: "/pages/order/createOrder",
          query,
        });
      } else {
        this.$router.push("/pages/public/login");
      }
    },

    //数量
    numberChange(data) {
      console.log(data);

      if (this.productData.activity == 1) {
        let eachPrice = (this.resultActivePrice * 1000) / this.num;

        this.num = data.number == 0 ? 1 : data.number;
        this.resultActivePrice = (parseFloat(this.num) * eachPrice) / 1000;
      } else {
        let eachPrice = (this.resultPrice * 1000) / this.num;

        this.num = data.number == 0 ? 1 : data.number;
        this.resultPrice = (parseFloat(this.num) * eachPrice) / 1000;
      }
    },
    //规格弹窗开关
    toggleSpec() {
      if (this.specClass === "show") {
        this.specClass = "hide";
        setTimeout(() => {
          this.specClass = "none";
        }, 250);
      } else if (this.specClass === "none") {
        this.specClass = "show";
      }
    },
    //收藏
    toFavorite() {
      this.collectSave();
    },
    //是否收藏
    checkCollect() {
      if (this.hasLogin) {
        this.$http
          .request(this.$http.pathMap.collectStoreUp, "get", {
            productId: this.productId,
          })
          .then((res) => {
            this.favorite = res.data;
          });
      }
    },
    //保存收藏
    collectSave() {
      if (this.hasLogin) {
        this.$http
          .request(this.$http.pathMap.collectSave, "post", {
            productId: this.productId,
            storeUp: !this.favorite,
          })
          .then((res) => {
            this.checkCollect();
          });
      } else {
        this.$router.push("/pages/public/login");
      }
    },
    stopPrevent() {},
  },
};
</script>

<style lang="scss" scoped>
.van-cell {
  padding: 10px 0 !important;
  ::v-deep .van-stepper__input {
    width: 47px;
  }
}
.containerdiv {
  padding-bottom: 120px;
  .contact {
    z-index: 999;
    position: fixed;
    bottom: 80px;
    right: 20px;
    display: inline-block;
    text-decoration: none;
    color: #000;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 100%;
    background: #fff;
    width: 40px;
    height: 40px;
    border: 1px solid #ccc;
    span {
      font-size: 12px;
    }
  }
}

.icon-you {
  font-size: $uni-font-size-base + 1px;
  color: #888;
}

.attr-scroll {
  max-height: calc(100vh - 180px);
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

.step {
  position: inherit;
}

.carousel {
  height: 375px;
  position: relative;

  .swiper {
    height: 100%;
  }

  .image-wrapper {
    width: 100%;
    height: 100%;
  }

  .swiper-item {
    display: flex;
    justify-content: center;
    align-content: center;
    overflow: hidden;
    position: relative;
    .try-div {
      position: absolute;
      bottom: 0;
      left: 30px;
      color: #fff;
      font-size: 12px;
    }
    .try-active {
      position: absolute;
      &::before {
        display: block;
        content: "";
        position: absolute;
        bottom: 0px;
        left: -30px;

        width: 600px;
        height: 70px;
        z-index: 9999;
        //background: pink;
      }
    }

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.active-div {
  padding: 0 15px;
  background-color: white;
}

.active-root {
  margin: auto;
  position: relative;
  height: 75px;
  width: 100%;
  border-radius: 5px;
  background: linear-gradient(to right, rgb(221, 178, 105), rgb(233, 195, 125));
}

.active-left {
  width: calc(100% - 122px);
  height: 75px;
  padding: 15px;
}

.active-right {
  position: absolute;
  height: 103px;
  /* width: 264upx; */
  padding: 0 15px;
  bottom: -6px;
  right: -7px;
  background-image: url("../../../static/kuang@2x.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.activ-image {
  width: 40px;
  max-height: 70px;
  margin-left: 10px;
}

.active-right span {
  margin-top: 5px;
  color: #a97f37;
  max-width: 115px;
  max-height: 23px;
  text-align: center;
  font-size: $uni-font-size-sm;
}

.pro-box {
  display: flex;
  align-items: center;
  margin-top: 5px;
  font-size: $uni-font-size-sm;
  color: $uni-font-size-base;
}

.progress-box {
  flex: 1;
  border-radius: 10px;
  overflow: hidden;
}

/* 标题简介 */
.introduce-section {
  background: #fff;
  padding: 10px 15px;
  .product-label {
    display: inline-block;
    padding: 0 5px;
    color: #fff;
    font-size: 14px;
    margin-right: 5px;
    border-radius: 5px;
  }
  .isHot {
    background: #e6a23c;
  }
  .isNew {
    background: #f56c6c;
  }
  .isRecommend {
    background: #67c23a;
  }
}

.title {
  font-size: 16px;
  color: $font-color-dark;
  /* height: 50upx; */
  line-height: 20px;
}

.active-price-box {
  display: flex;
  align-items: baseline;
  height: 32px;
  font-size: 13px;
  color: white;
}

.active-price {
  font-size: $uni-font-size-lg + 13px;
  font-weight: bold;
}

.active-m-price {
  margin-left: 7px;
  color: #e1e1e1;
  text-decoration: line-through;
}

.active-price-tip {
  font-size: $uni-font-size-lg + 3px;
}

.active-volume {
  color: #f1f1f1;
}

.price-box {
  display: flex;
  align-items: baseline;
  /* height: 64upx; */
  padding: 5px 0;
  font-size: 13px;
  color: var(--theme-font-color);
}

.price {
  font-size: $uni-font-size-lg + 3px;
}

.price-tip {
  font-size: $uni-font-size-lg;
}

.m-price {
  margin: 0 6px;
  color: $font-color-light;
  text-decoration: line-through;
}

.coupon-tip {
  align-items: center;
  padding: 2px 5px;
  background: var(--theme-font-color);
  font-size: $uni-font-size-sm;
  color: #fff;
  border-radius: 3px;
  line-height: 1;
  transform: translateY(-2px);
}

.bot-row {
  display: flex;
  align-items: center;
  height: 25px;
  font-size: $uni-font-size-sm;
  color: $font-color-light;

  span {
    flex: 1;
  }
}

.c-list {
  font-size: $uni-font-size-sm + 1px;
  color: $font-color-base;
  background: #fff;

  .c-row {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    position: relative;
  }
  .tited {
    font-weight: 700;
    color: black;
  }

  .tit {
    min-width: 70px;
    max-width: 100px;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 10px;
  }

  .con {
    flex: 1;
    text-align: left;
    color: $font-color-dark;

    .selected-span {
      margin-right: 5px;
      .selectedType {
        color: #000 !important;
        font-weight: 500 !important;
      }
    }
  }

  .bz-list {
    font-size: $uni-font-size-sm + 1px;
    color: $font-color-dark;

    span {
      display: inline-block;
      margin-right: 15px;
    }
  }

  .con-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    color: $font-color-dark;
    line-height: 20px;
  }

  .red {
    color: var(--theme-font-color);
  }
}

/* 评价 */
.eva-section {
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
  background: #fff;
  margin-top: 8px;

  .e-header {
    display: flex;
    align-items: center;
    height: 35px;
    font-size: $uni-font-size-sm + 1px;
    color: $font-color-light;

    .tit {
      font-size: $uni-font-size-base + 1px;
      color: $font-color-dark;
      margin-right: 2px;
    }

    .tip {
      flex: 1;
      text-align: right;
    }

    .icon-you {
      margin-left: 5x;
    }
  }
}

.eva-box {
  display: flex;
  padding: 10px 0;

  .portrait {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 100px;
  }

  .right {
    flex: 1;
    display: flex;
    flex-direction: column;
    font-size: $uni-font-size-base;
    color: $font-color-base;
    padding-left: 13px;

    .con {
      font-size: $uni-font-size-base;
      color: $font-color-dark;
      padding: 10px 0;
    }

    .bot {
      display: flex;
      justify-content: space-between;
      font-size: $uni-font-size-sm;
      color: $font-color-light;
    }
  }
}

/*  详情 */
.detail-desc {
  background: #fff;
  margin-top: 8px;
  position: relative;
  max-width: 100%;

  .d-header {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
    font-size: $uni-font-size-base + 1px;
    color: $font-color-dark;
    position: relative;

    span {
      padding: 0 10px;
      background: #fff;
      position: relative;
      z-index: 1;
    }

    &:after {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%);
      width: 150px;
      height: 0;
      content: "";
      border-bottom: 1px solid #ccc;
    }
  }
}
/* 规格选择弹窗 */
.attr-content {
  padding: 5px 15px;

  .a-t {
    display: flex;

    .a-t-img {
      margin-top: -20px;
      border-radius: 4px;
    }

    .right {
      display: flex;
      flex-direction: column;
      padding-left: 12px;
      font-size: $uni-font-size-sm + 1px;
      color: $font-color-base;
      line-height: 21px;

      .price {
        font-size: $uni-font-size-lg;
        color: var(--theme-font-color);
      }

      .selected-span {
        margin-right: 5px;
        .selectedType {
          color: #000 !important;
          font-weight: 500 !important;
        }
      }
    }
  }

  .attr-list {
    display: flex;
    flex-direction: column;
    font-size: $uni-font-size-base + 1px;
    color: $font-color-base;
    padding-top: 15px;
    padding-left: 5px;
  }

  .item-list {
    padding: 10px 0 0;
    display: flex;
    flex-wrap: wrap;

    .item-item {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #eee;
      margin-right: 10px;
      margin-bottom: 10px;
      border-radius: 10px;
      min-width: 30px;
      height: 30px;
      padding: 0 5px;
      font-size: $uni-font-size-base;
      color: $font-color-dark;

      .item-color {
        width: 15px;
        height: 15px;
        border-radius: 2px;
        margin-right: 5px;
      }
      .item-image {
        width: 25px;
        height: 25px;
        border-radius: 2px;
        margin-right: 5px;
      }
    }

    .selected {
      background: #fbebee;
      color: var(--theme-font-color);
    }

    .disabled {
      background: #f8f8f8;
      color: #a0a0a0;
    }
  }
}

/*  弹出层 */
.popup {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 99;

  &.show {
    display: block;

    .mask {
      animation: showPopup 0.2s linear both;
    }

    .layer {
      animation: showLayer 0.2s linear both;
    }
  }

  &.hide {
    .mask {
      animation: hidePopup 0.2s linear both;
    }

    .layer {
      animation: hideLayer 0.2s linear both;
    }
  }

  &.none {
    display: none;
  }

  .mask {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.4);
  }

  .layer {
    position: fixed;
    z-index: 99;
    bottom: 0;
    width: 100%;
    min-height: 40vh;
    border-radius: 5px 5px 0 0;
    background-color: #fff;

    .btnCom {
      height: 33px;
      line-height: 33px;
      border-radius: 50px;
      background: var(--theme-font-color);
      font-size: $uni-font-size-base + 1px;
      color: #fff;
      margin: 8px auto 10px;
    }
  }

  @keyframes showPopup {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  @keyframes hidePopup {
    0% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  @keyframes showLayer {
    0% {
      transform: translateY(120%);
    }

    100% {
      transform: translateY(0%);
    }
  }

  @keyframes hideLayer {
    0% {
      transform: translateY(0);
    }

    100% {
      transform: translateY(120%);
    }
  }
}

/* 底部操作菜单 */
.page-bottom {
  position: fixed;
  left: 0px;
  bottom: 0;
  z-index: 95;
  display: flex;
  justify-content: space-around;
  padding-top: 10px;
  width: 100%;
  height: 70px;
  background: #fff;
  border-radius: 8px;
  .authBox {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;
  }

  .p-b-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: $uni-font-size-sm;
    color: $font-color-base;
    width: 48px;
    height: 40px;

    .yticon {
      font-size: 20px;
      line-height: 24px;
      color: $font-color-light;
    }

    &.active,
    &.active .yticon {
      color: var(--theme-font-color);
    }

    .icon-fenxiang2 {
      font-size: 21px;
      transform: translateY(-2upx);
    }

    .icon-shoucang {
      font-size: 23px;
    }
  }

  .action-btn-group {
    display: flex;
    flex: 1;
    overflow: hidden;
    margin-left: 10px;
    margin-right: 10px;
    position: relative;
    justify-content: center;
    .action-buy {
      width: 100px;
      height: 40px;
      background: #496bcb;
      border-radius: 0 100px 100px 0;
      opacity: 1;
      text-align: center;
      line-height: 40px;
      color: #fff;
    }
    .action-buy-two {
      width: 350px;
      height: 40px;
      background: #496bcb;
      opacity: 1;
      text-align: center;
      line-height: 40px;
      color: #fff;
    }
    .action-btn {
      width: 100px;
      height: 40px;
      background: #ffd014;
      border-radius: 100px 0px 0px 100px;
      opacity: 1;
      text-align: center;
      line-height: 40px;
      color: #fff;
    }
    .action-btn::after {
      border: none;
    }
  }
}
.activBtn {
  background-color: var(--theme-font-color);
  color: white;
  font-size: 15px;
  display: flex;
  justify-content: center;
  align-content: center;
  border-radius: 10px;
  padding: 0 5px;
}
.goup-div {
}
.van-tag {
  transform: scale(0.7);
}
</style>
